import authApi from '../../utils/AxiosConfig';
import authHeader from '../../utils/authHeader';

const API_URL = '/orders';

// Create Order
const createOrder = async (cartData) => {
    console.log("Payload sent to API:", cartData); // Debug log
    const response = await authApi.post(
        API_URL,
        cartData,
        {
            headers: authHeader(),
        }
    );
    return response.data;
};

// Get All Orders
const getOrders = async (token) => {
    const response = await authApi.get(API_URL, {
        headers: authHeader(token), // Attach authentication header
    });
    return response.data;
};

// Get Order by ID
const getOrderById = async (orderId, token) => {
    const response = await authApi.get(`${API_URL}/${orderId}`, {
        headers: authHeader(token), // Attach authentication header
    });
    return response.data;
};

// Get All Orders (For Admin)
const getAdminOrders = async (token) => {
    const response = await authApi.get(`/admin/orders`, {
        headers: authHeader(token),
    });
    return response.data;
};


const orderService = {
    createOrder,
    getOrders,
    getAdminOrders,
    getOrderById,
};

export default orderService;
